import { useOutletContext, useParams } from "react-router"
import { ErrorComponent } from "@/shared/components/ErrorComponent/ErrorComponent"
import { Loading } from "@/shared/components/Loading/Loading"
import { MicroFrontendContent } from "../components/MicroFrontendContent/MicroFrontendContent"
import { MicroFrontendManifest } from "../components/MicroFrontendContent/MicroFrontendManifest"
import { useMicroFrontendUrl } from "../hooks/useMicroFrontendUrls"
import type { CustomerContext } from "../types/CustomerContext"

export function MicrofrontendPage() {
  const { microFrontendId } = useParams()
  const query = useMicroFrontendUrl(microFrontendId)
  const { customer } = useOutletContext<CustomerContext>()
  const { data: microFrontendUrl, isLoading, refetch, error } = query

  if (isLoading) {
    return <Loading />
  }

  if (error || !microFrontendUrl) {
    return <ErrorComponent error={error} onRetry={() => void refetch()} />
  }

  if (microFrontendUrl.importUrl.endsWith("manifest.json")) {
    // this is only if micro-frontend url is provided via manifest file
    return (
      <MicroFrontendManifest
        importUrl={microFrontendUrl.importUrl}
        webComponentName={microFrontendUrl.webComponentName}
        customerId={customer.id}
      />
    )
  }

  return (
    <MicroFrontendContent
      importUrl={microFrontendUrl.importUrl}
      webComponentName={microFrontendUrl.webComponentName}
      customerId={customer.id}
    />
  )
}
